
import React, { useState } from 'react';
import { createFFmpeg, fetchFile } from '@ffmpeg/ffmpeg';




export default function Test() {

    const [videoBlob, setVideoBlob] = useState(null);
    const [progress, setProgress] = useState(0);
    var durationConvert = 0;

    const ffmpeg = createFFmpeg({

        progress: (e) => {
            if (e.duration) {
                durationConvert = e.duration
            }
            if (e.time) {
                var fin = Math.round(((e.time + durationConvert) / durationConvert * 100) - 100)
                setProgress(fin)
            }
        },
        log: true,
    });

    const doTranscode = async (video) => {
        await ffmpeg.load();
        ffmpeg.FS('writeFile', video.name, await fetchFile(video));
        await ffmpeg.run('-i', video.name, '-c:v', 'libx264', '-vf', 'scale=720:-2,format=yuv420p', '-c:a', 'copy', '-movflags', '+faststart', 'output.mp4');
        const data = ffmpeg.FS('readFile', 'output.mp4');
        const blob = new Blob([data.buffer], { type: 'video/mp4' })
        setVideoBlob(URL.createObjectURL(blob));
    };


    return (
        <>
            <input type={'file'} onChange={async (e) => {
                await doTranscode(e.target.files[0])
                // setVideoBlob(e.target.files[0])

                // setVideoBlob(fileD)
            }} />
            <span>{progress}</span>
            <video id={"id_video"} autoPlay={false} controls playsInline webkit-playsinline="true" crossOrigin="anonymous" preload="metadata" loop={true}>
                {videoBlob && <source src={videoBlob} type={`video/mp4`} />}
                Your browser does not support the video tag.
            </video>
        </>
    )

}